const UTM_STORAGE_KEY = 'utm_params';
const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;

export type UtmParams = Partial<Record<(typeof UTM_PARAMS)[number], string>>;

export function captureUtmParams(locationSearch = window.location.search): void {
  if (!locationSearch || sessionStorage.getItem(UTM_STORAGE_KEY)) {
    return;
  }
  const search = new URLSearchParams(locationSearch);
  const params: UtmParams = {};
  UTM_PARAMS.forEach((key) => {
    const value = search.get(key);
    if (value) {
      params[key] = value;
    }
  });
  if (Object.keys(params).length > 0) {
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(params));
  }
}

export function getUtmParams(): UtmParams | null {
  try {
    const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function clearUtmParams(): void {
  sessionStorage.removeItem(UTM_STORAGE_KEY);
}
